import get from 'lodash/get';
import * as Api from '../api';
import * as Mappers from '../mappers';
import * as Types from '../types';

const MyStats = (): [string[], () => Promise<Types.IQuery.MyStats>] => [
  ['result', 'my-stats'],
  async () => {
    const { data } = await Api.MyStats();

    const stats = Mappers.MyStats(get(data, 'data'));

    return {
      stats,
    };
  },
];

export default MyStats;
